import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ApiService, JSONHash } from 'angular-lib';
import { FeedbackComponent } from '../../feedback/feedback.component';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../../services/loader.service';

@Component({
    selector: 'ez-notifications',
    template: require('./notifications.component.html'),
    styles: [require('./notifications.component.less')]
})
export class NotificationsComponent implements OnInit, AfterViewInit {
    @ViewChild(FeedbackComponent) public feedback: FeedbackComponent;
    public datas: JSONHash;

    constructor(
        private apiService: ApiService,
        private route: ActivatedRoute,
        private loaderService: LoaderService
    ) {
    }

    public ngAfterViewInit() {
        let params = this.route.snapshot.queryParams;
        if (params.action === 'disable') {
            this.feedback.toggle();
            this.loaderService.show();
            this.apiService.disableNotifications().subscribe(
                (res) => {
                    this.loaderService.hide();
                },
                error => {
                    this.loaderService.hide();
                }
            );
        }
    }

    public ngOnInit() {
        this.loaderService.show();
        this.apiService.nofitications().subscribe(
            (data) => {
                this.datas = data;

                let emailPerDay = [];
                for (let item in this.datas.emailPerDay) {
                    if (this.datas.emailPerDay.hasOwnProperty(item) && item) {
                        emailPerDay.push(item);
                    }
                }
                this.datas.emailPerDay = emailPerDay;
                this.loaderService.hide();
            },
            error => {
                this.loaderService.hide();
            }
        );
    }

    public onChangeNotifications(notif) {
        let formatedNotif = {};
        formatedNotif[notif.type] = notif.values;
        this.saveNotification({notification: formatedNotif});
    }

    public onChangeParameters(param) {
        let formatedNotif = {};
        formatedNotif[param.type] = param.value;
        this.saveNotification({notification: formatedNotif});
    }

    public onChangeOthers(event) {
        let limit = this.datas.notificationCountParams.limit;
        if (event !== undefined) {
            limit = this.datas.notificationCountParams.limit = event;
        }
        let data = {
            counter: this.datas.notificationCountParams.limit,
            resetOnConnect: this.datas.notificationCountParams.reset_on_connect
        };

        this.saveNotification({notification: data});
    }

    public saveNotification(data) {
        this.apiService.saveNotification(data).subscribe((res) => {});
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/account/notifications/notifications.component.ts